import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import * as memberAction from '../../../../redux/actions/member.action';
import './retireePortalSettings.scss';

const RetireePortalSettings = () => {
  const dispatch = useDispatch();
  const { entityId } = useParams();
  const [isEnabled, setIsEnabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const { memberDetails } = useSelector((state) => ({
    memberDetails: state.member.memberDetails,
  }));

  useEffect(() => {
    if (memberDetails) {
      setIsEnabled(memberDetails.location_has_retiree_portal || false);
    }
  }, [memberDetails]);

  const handleToggleChange = async () => {
    setIsLoading(true);
    setShowSuccessAlert(false);
    setShowErrorAlert(false);
    setErrorMessage('');

    try {
      const newStatus = !isEnabled;
      const formData = new FormData();
      
      // Create the updated member object
      const formBody = {
        ...memberDetails,
        location_has_retiree_portal: newStatus
      };

      formData.append("location", JSON.stringify(formBody));
      
      await memberAction.update(dispatch, entityId, formData);
      
      // Update local state
      setIsEnabled(newStatus);
      
      // Show success message
      setShowSuccessAlert(true);
      setTimeout(() => setShowSuccessAlert(false), 3000);
      
      // Refresh member details
      memberAction.fetchDetails(dispatch, entityId);
      
    } catch (error) {
      console.error('Error updating retiree portal setting:', error);
      setErrorMessage('Failed to update retiree portal setting. Please try again.');
      setShowErrorAlert(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="retiree-portal-settings">
      <div className="retiree-portal-header">
        <h4>Medicare Portal Settings</h4>
        <p className="text-muted">
          Configure whether this member location should have access to the retiree portal.
        </p>
      </div>

      {showSuccessAlert && (
        <Alert 
          variant="success" 
          onClose={() => setShowSuccessAlert(false)}
          dismissible
        >
          Medicare portal setting updated successfully!
        </Alert>
      )}

      {showErrorAlert && (
        <Alert 
          variant="danger" 
          onClose={() => setShowErrorAlert(false)}
          dismissible
        >
          {errorMessage}
        </Alert>
      )}

      <div className="retiree-portal-content">
        <div className="setting-item">
          <div className="setting-info">
            <h5>Enable Medicare Portal</h5>
            <p className="text-muted">
              When enabled, this member location will have access to the retiree portal features.
            </p>
          </div>
          
          <div className="setting-control">
            <Form.Check
              type="switch"
              id="retiree-portal-toggle"
              label={isEnabled ? "Enabled" : "Disabled"}
              checked={isEnabled}
              onChange={handleToggleChange}
              disabled={isLoading}
              className="custom-switch"
            />
          </div>
        </div>

        <div className="setting-status">
          <strong>Current Status: </strong>
          <span className={`status-badge ${isEnabled ? 'enabled' : 'disabled'}`}>
            {isEnabled ? 'Medicare Portal Enabled' : 'Medicare Portal Disabled'}
          </span>
        </div>
      </div>
    </div>
  );
};

export default RetireePortalSettings;